export default [
  {
    name: 'terms/privacy',
    path: '/terms/privacy',
    meta: {
      requireSignin: false,
    },
    component: () => import('@/pages/terms/PrivacyPolicy.vue'),
  },
  {
    name: 'terms/withdrawal',
    path: '/terms/withdrawal',
    meta: {
      requireSignin: false,
    },
    component: () => import('@/pages/terms/WithdrawalPolicy.vue'),
  },
  {
    name: 'terms/service',
    path: '/terms/service',
    meta: {
      requireSignin: false,
    },
    component: () => import('@/pages/terms/ServiceTerm.vue'),
  },
  {
    name: 'terms/detail',
    path: '/terms/:code',
    meta: {
      requireSignin: false,
    },
    component: () => import('@/pages/terms/TermsDetail.vue'),
  },
]
